import { BlackPearlTemplate } from "@blackpearlmail/cerberus"
import React from "react"
import { Image } from "../../../../../../components/image-upload/model"

export interface IImageProps {
    template: BlackPearlTemplate
    updateTemplate: React.Dispatch<React.SetStateAction<BlackPearlTemplate>>
    images: BrandingImage[]
    callback: React.Dispatch<React.SetStateAction<BrandingImage[]>>
    formik: any
}

export interface BrandingImage {
    type: ImageType
    image: Image | null
    active: boolean
}

export type ImageType = "logo" | "profile" | "banner"

export const defaultBrandingImages: BrandingImage[] = [
    {
        type: "logo",
        active: true,
        image: null,
    },
    {
        type: "profile",
        active: true,
        image: null,
    },
    {
        type: "banner",
        active: true,
        image: null,
    },
]

export const defaultLogo = {
    url: "https://blackpearlmail.com/wp-content/uploads/2022/07/SALTSWEET_LOGO.png",
    height: 98.5782,
    width: 200,
    format: "image/png",
}

export const defaultProfile = {
    url: "https://blackpearlmail.com/wp-content/uploads/2022/07/PROFILE.png",
    height: 100,
    width: 100,
    format: "image/png",
}

export const defaultBanner = {
    url: "https://blackpearlmail.com/wp-content/uploads/2022/07/BANNER.png",
    height: 572,
    width: 1360,
    format: "image/png",
}
